import SiteContext from "../context/SiteContext";
import {useContext, useEffect, useRef} from "react";
import IndustryChatDemoMessage from "./IndustryChatDemoMessage";
import IndustryChatDemoComposer from "./IndustryChatDemoComposer";
const IndustryChatDemo = () => {

    const {industries, currentIndustryIndex, currentMessageIndex, updateCurrentMessageIndex} = useContext(SiteContext);


    const currentIndustryObject = industries[currentIndustryIndex];

    const messages = currentIndustryObject.messages;

    const scrollRef = useRef(null);

    // useEffect(() => {
    //     fetchData()
    // }, [fetchData]);


    useEffect(() => {
        if(currentMessageIndex === -1){
            updateCurrentMessageIndex();
        }
    }, [currentMessageIndex, updateCurrentMessageIndex]);


    useEffect(() => {
        // Scroll to the bottom when new items are added
        const scrollTimer = setTimeout(() => {
            scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
        }, 250);

        return () => {
            clearTimeout(scrollTimer);
        }
    }, [updateCurrentMessageIndex]);



    return (
        <div className="chat-window">
            <header className="chat-window-header">
                {currentIndustryObject.headerTitle}
                <div className="chat-window-header-actions">

                    <svg height="30" width="30" viewBox="0 96 960 960"><path d="M796 935 533 672q-30 26-69.959 40.5T378 727q-108.162 0-183.081-75Q120 577 120 471t75-181q75-75 181.5-75t181 75Q632 365 632 471.15 632 514 618 554q-14 40-42 75l264 262-44 44ZM377 667q81.25 0 138.125-57.5T572 471q0-81-56.875-138.5T377 275q-82.083 0-139.542 57.5Q180 390 180 471t57.458 138.5Q294.917 667 377 667Z"/></svg>
                    <img className="chat-window-header-avatar" src={currentIndustryObject.user_avatar}/>
                </div>

            </header>
            <div className="chat-window-scroller" ref={scrollRef}>
                {messages.map((message, index) => {
                    if(index <= currentMessageIndex){
                        if(message.user === "bast"){
                            return (
                                <div key={index} className="chat-window-message-wrapper">
                                    <IndustryChatDemoMessage scrollRef={scrollRef} isGhost={false} messageIndex={index} industry={currentIndustryObject} message={message}/>
                                    <IndustryChatDemoMessage isGhost={true} messageIndex={index} industry={currentIndustryObject} message={message}/>
                                </div>

                            )
                        }else if(message.sent){
                            return (
                                <div key={index} className="chat-window-message-wrapper chat-window-message-wrapper--user">
                                    <IndustryChatDemoMessage scrollRef={scrollRef} isGhost={false} messageIndex={index} industry={currentIndustryObject} message={message}/>
                                    <IndustryChatDemoMessage isGhost={true} messageIndex={index} industry={currentIndustryObject} message={message}/>
                                </div>

                            )
                        }
                    }


                })}
            </div>
            <footer className="chat-window-footer">
                <svg className="chat-window-footer-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 96 960 960"><path d="M360 816 121 577l239-239 43 43-167 167h544V376h60v231H237l166 166-43 43Z"/></svg>
                {
                    messages[currentMessageIndex] && messages[currentMessageIndex].user !== "bast" &&
                    !messages[currentMessageIndex].sent
                    && <IndustryChatDemoComposer messageIndex={currentMessageIndex} message={messages[currentMessageIndex]}/>
                }

            </footer>
        </div>

    );
};

export default IndustryChatDemo;
